/**
 * A tiny bus for "a load changed on the board": the socket handler for the board's load updates calls `notifyWorklistChanged`,
 * and the Agent page's worklist re-reads (debounced) when it hears it. The worklist reads the database, so the bus carries no
 * data, only the signal.
 */
type Listener = () => void

const listeners = new Set<Listener>()

/** Called for every board load update received on the socket. */
export const notifyWorklistChanged = (): void => {
    listeners.forEach((listener) => listener())
}

/** Subscribes to board load updates; returns the unsubscribe. */
export const onWorklistChanged = (listener: Listener): (() => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
